import React, { ReactElement } from 'react';

import ToolbarPopupTool from '../../ToolbarPopupTool';
import TagsToolbarPopup from './popup/TagsToolbarPopup';

import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

export type TagsToolProps = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const TagsTool = (props: TagsToolProps): ReactElement => {
    return (
        <ToolbarPopupTool
            {...props}
            popupId={PopupIds.TAGS_TOOL}
            toolName={'tag'}
            buttonSelector=".TagTool .icon"
            PopupComponent={TagsToolbarPopup}
        />
    );
};

export default TagsTool;
